export default function () {
    const theme = window.localStorage.getItem('currentTheme') || 'light';

    if (theme === 'system') {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        return isDark ? 'dark' : 'light';
    }

    return theme;
};

